import { BasicInfoSectionCombinedProps } from './types';

const usePresenter = (props: BasicInfoSectionCombinedProps): BasicInfoSectionCombinedProps => {
  return props;
};

export default usePresenter;
